import React from "react";
import { useSubscriptionProviderContext } from "../components/SubscriptionProvider";

export function useSubscriptionSource(source: string | null) {
  const {
    actions: { setSource },
  } = useSubscriptionProviderContext();

  React.useEffect(() => {
    setSource(source);
  }, [source]);
}
